import React, { useState, useEffect } from 'react';
import { pushDidukungBrowser, aktifkanPushNotif, cekStatusPushNotif } from './pushNotif';

export default function TombolPushNotif() {
  const [aktif, setAktif] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [didukung, setDidukung] = useState(true);

  useEffect(() => {
    setDidukung(pushDidukungBrowser());
    cekStatusPushNotif().then(setAktif);
  }, []);

  const handleAktifkan = async () => {
    setLoading(true);
    setError('');
    try {
      await aktifkanPushNotif();
      setAktif(true);
    } catch (err) {
      setError(err.message || 'Gagal mengaktifkan notifikasi.');
    }
    setLoading(false);
  };

  return (
    <div className="px-4 py-3.5" style={{ borderTop: '1px solid var(--border)' }}>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-lg">🔔</span>
          <div>
            <p style={{ color: 'var(--text-primary)' }} className="text-sm font-medium">Notifikasi Push</p>
            <p style={{ color: 'var(--text-muted)' }} className="text-xs">
              {!didukung ? 'Tidak didukung di browser ini' : aktif ? 'Aktif — kamu akan dapat pengingat' : 'Pengingat latihan & tryout baru'}
            </p>
          </div>
        </div>
        {didukung && (
          aktif ? (
            <span className="text-xs font-semibold px-2.5 py-1 rounded-full" style={{ backgroundColor: 'rgba(74,222,128,0.15)', color: 'var(--success)' }}>
              ✓ Aktif
            </span>
          ) : (
            <button onClick={handleAktifkan} disabled={loading}
              className="text-xs font-semibold px-3 py-1.5 rounded-lg"
              style={{ backgroundColor: 'var(--accent)', color: '#fff' }}>
              {loading ? 'Memproses...' : 'Aktifkan'}
            </button>
          )
        )}
      </div>
      {error && <p className="text-xs mt-2" style={{ color: '#f87171' }}>{error}</p>}
    </div>
  );
}
